import { ITheme } from "./theme.type";

export const lightTheme: ITheme = {
  name: "light",
  palette: {
    // Schemes
    primary: {
      main: "#4c43ac",
      opacity: {
        "08": "rgba(72, 94, 146, 0.08)",
        "12": "rgba(72, 94, 146, 0.12)",
        "16": "rgba(72, 94, 146, 0.16)",
      },
    },
    "surface-tint": {
      main: "rgba(105, 145, 214, 1.00)",
      opacity: {
        "08": "rgba(72, 94, 146, 0.08)",
        "12": "rgba(72, 94, 146, 0.12)",
        "16": "rgba(72, 94, 146, 0.16)",
      },
    },
    "on-primary": {
      main: "rgba(255, 255, 255, 1.00)",
      opacity: {
        "08": "rgba(255, 255, 255, 0.08)",
        "12": "rgba(255, 255, 255, 0.12)",
        "16": "rgba(255, 255, 255, 0.16)",
      },
    },
    "primary-container": {
      main: "rgba(211, 227, 253, 1.00)",
      opacity: {
        "08": "rgba(173, 195, 254, 0.08)",
        "12": "rgba(173, 195, 254, 0.12)",
        "16": "rgba(173, 195, 254, 0.16)",
      },
    },
    "on-primary-container": {
      main: "rgba(4, 30, 73, 1.00)",
      opacity: {
        "08": "rgba(50, 69, 116, 0.08)",
        "12": "rgba(50, 69, 116, 0.12)",
        "16": "rgba(50, 69, 116, 0.16)",
      },
    },
    secondary: {
      main: "rgba(0, 99, 155, 1.00)",
      opacity: {
        "08": "rgba(88, 95, 114, 0.08)",
        "12": "rgba(88, 95, 114, 0.12)",
        "16": "rgba(88, 95, 114, 0.16)",
      },
    },
    "on-secondary": {
      main: "rgba(255, 255, 255, 1.00)",
      opacity: {
        "08": "rgba(255, 255, 255, 0.08)",
        "12": "rgba(255, 255, 255, 0.12)",
        "16": "rgba(255, 255, 255, 0.16)",
      },
    },
    "secondary-container": {
      main: "rgba(194, 231, 255, 1.00)",
      opacity: {
        "08": "rgba(217, 223, 246, 0.08)",
        "12": "rgba(217, 223, 246, 0.12)",
        "16": "rgba(217, 223, 246, 0.16)",
      },
    },
    "on-secondary-container": {
      main: "rgba(0, 29, 53, 1.00)",
      opacity: {
        "08": "rgba(64, 70, 89, 0.08)",
        "12": "rgba(64, 70, 89, 0.12)",
        "16": "rgba(64, 70, 89, 0.16)",
      },
    },
    error: {
      main: "rgba(179, 38, 30, 1.00)",
      opacity: {
        "08": "rgba(179, 38, 30, 0.08)",
        "12": "rgba(179, 38, 30, 0.12)",
        "16": "rgba(179, 38, 30, 0.16)",
      },
    },
    "on-error": {
      main: "rgba(255, 255, 255, 1.00)",
      opacity: {
        "08": "rgba(255, 255, 255, 0.08)",
        "12": "rgba(255, 255, 255, 0.12)",
        "16": "rgba(255, 255, 255, 0.16)",
      },
    },
    "error-container": {
      main: "rgba(249, 222, 220, 1.00)",
      opacity: {
        "08": "rgba(249, 222, 220, 0.08)",
        "12": "rgba(249, 222, 220, 0.12)",
        "16": "rgba(249, 222, 220, 0.16)",
      },
    },
    "on-error-container": {
      main: "rgba(140, 29, 24, 1.00)",
      opacity: {
        "08": "rgba(140, 29, 24, 0.08)",
        "12": "rgba(140, 29, 24, 0.12)",
        "16": "rgba(140, 29, 24, 0.16)",
      },
    },
    background: {
      main: "rgba(255, 255, 255, 1.00)",
      opacity: {
        "08": "rgba(253, 247, 255, 0.08)",
        "12": "rgba(253, 247, 255, 0.12)",
        "16": "rgba(253, 247, 255, 0.16)",
      },
    },
    "on-background": {
      main: "rgba(29, 27, 32, 1.00)",
      opacity: {
        "08": "rgba(29, 27, 32, 0.08)",
        "12": "rgba(29, 27, 32, 0.12)",
        "16": "rgba(29, 27, 32, 0.16)",
      },
    },
    surface: {
      main: "rgba(255, 255, 255, 1.00)",
      opacity: {
        "08": "rgba(250, 248, 255, 0.08)",
        "12": "rgba(250, 248, 255, 0.12)",
        "16": "rgba(250, 248, 255, 0.16)",
      },
    },
    "on-surface": {
      main: "rgba(31, 31, 31, 1.00)",
      opacity: {
        "08": "rgba(26, 27, 33, 0.08)",
        "12": "rgba(26, 27, 33, 0.12)",
        "16": "rgba(26, 27, 33, 0.16)",
      },
    },
    "surface-variant": {
      main: "rgba(225, 227, 225, 1.00)",
      opacity: {
        "08": "rgba(226, 226, 233, 0.08)",
        "12": "rgba(226, 226, 233, 0.12)",
        "16": "rgba(226, 226, 233, 0.16)",
      },
    },
    "on-surface-variant": {
      main: "rgba(68, 71, 70, 1.00)",
      opacity: {
        "08": "rgba(68, 70, 79, 0.08)",
        "12": "rgba(68, 70, 79, 0.12)",
        "16": "rgba(68, 70, 79, 0.16)",
      },
    },
    outline: {
      main: "rgba(116, 119, 117, 1.00)",
      opacity: {
        "08": "rgba(117, 119, 128, 0.08)",
        "12": "rgba(117, 119, 128, 0.12)",
        "16": "rgba(117, 119, 128, 0.16)",
      },
    },
    "outline-variant": {
      main: "rgba(196, 199, 197, 1.00)",
      opacity: {
        "08": "rgba(197, 198, 208, 0.08)",
        "12": "rgba(197, 198, 208, 0.12)",
        "16": "rgba(197, 198, 208, 0.16)",
      },
    },
    shadow: {
      main: "rgba(0, 0, 0, 1.00)",
      opacity: {
        "08": "rgba(0, 0, 0, 0.08)",
        "12": "rgba(0, 0, 0, 0.12)",
        "16": "rgba(0, 0, 0, 0.16)",
      },
    },
    scrim: {
      main: "rgba(0, 0, 0, 1.00)",
      opacity: {
        "08": "rgba(0, 0, 0, 0.08)",
        "12": "rgba(0, 0, 0, 0.12)",
        "16": "rgba(0, 0, 0, 0.16)",
      },
    },
    "inverse-on-surface": {
      main: "rgba(48, 48, 48, 1.00)",
      opacity: {
        "08": "rgba(238, 237, 244, 0.08)",
        "12": "rgba(238, 237, 244, 0.12)",
        "16": "rgba(238, 237, 244, 0.16)",
      },
    },
    "inverse-surface": {
      main: "rgba(242, 242, 242, 1.00)",
      opacity: {
        "08": "rgba(40, 42, 47, 0.08)",
        "12": "rgba(40, 42, 47, 0.12)",
        "16": "rgba(40, 42, 47, 0.16)",
      },
    },
    "inverse-primary": {
      main: "#8b81fc",
      opacity: {
        "08": "rgba(176, 198, 255, 0.08)",
        "12": "rgba(176, 198, 255, 0.12)",
        "16": "rgba(176, 198, 255, 0.16)",
      },
    },
    "primary-fixed": {
      main: "rgba(211, 227, 253, 1.00)",
      opacity: {
        "08": "rgba(173, 195, 254, 0.08)",
        "12": "rgba(173, 195, 254, 0.12)",
        "16": "rgba(173, 195, 254, 0.16)",
      },
    },
    "on-primary-fixed": {
      main: "rgba(4, 30, 73, 1.00)",
      opacity: {
        "08": "rgba(0, 25, 70, 0.08)",
        "12": "rgba(0, 25, 70, 0.12)",
        "16": "rgba(0, 25, 70, 0.16)",
      },
    },
    "primary-fixed-dim": {
      main: "#8b81fc",
      opacity: {
        "08": "rgba(146, 168, 225, 0.08)",
        "12": "rgba(146, 168, 225, 0.12)",
        "16": "rgba(146, 168, 225, 0.16)",
      },
    },
    "on-primary-fixed-variant": {
      main: "rgba(8, 66, 160, 1.00)",
      opacity: {
        "08": "rgba(50, 69, 116, 0.08)",
        "12": "rgba(50, 69, 116, 0.12)",
        "16": "rgba(50, 69, 116, 0.16)",
      },
    },
    "secondary-fixed": {
      main: "rgba(194, 231, 255, 1.00)",
      opacity: {
        "08": "rgba(217, 223, 246, 0.08)",
        "12": "rgba(217, 223, 246, 0.12)",
        "16": "rgba(217, 223, 246, 0.16)",
      },
    },
    "on-secondary-fixed": {
      main: "rgba(0, 29, 53, 1.00)",
      opacity: {
        "08": "rgba(21, 27, 44, 0.08)",
        "12": "rgba(21, 27, 44, 0.12)",
        "16": "rgba(21, 27, 44, 0.16)",
      },
    },
    "secondary-fixed-dim": {
      main: "rgba(127, 207, 255, 1.00)",
      opacity: {
        "08": "rgba(192, 198, 220, 0.08)",
        "12": "rgba(192, 198, 220, 0.12)",
        "16": "rgba(192, 198, 220, 0.16)",
      },
    },
    "on-secondary-fixed-variant": {
      main: "rgba(0, 74, 119, 1.00)",
      opacity: {
        "08": "rgba(64, 70, 89, 0.08)",
        "12": "rgba(64, 70, 89, 0.12)",
        "16": "rgba(64, 70, 89, 0.16)",
      },
    },
    "surface-dim": {
      main: "rgba(211, 219, 229, 1.00)",
      opacity: {
        "08": "rgba(218, 217, 224, 0.08)",
        "12": "rgba(218, 217, 224, 0.12)",
        "16": "rgba(218, 217, 224, 0.16)",
      },
    },
    "surface-bright": {
      main: "rgba(250, 248, 255, 1.00)",
      opacity: {
        "08": "rgba(250, 248, 255, 0.08)",
        "12": "rgba(250, 248, 255, 0.12)",
        "16": "rgba(250, 248, 255, 0.16)",
      },
    },
    "surface-container-lowest": {
      main: "rgba(255, 255, 255, 1.00)",
      opacity: {
        "08": "rgba(255, 255, 255, 0.08)",
        "12": "rgba(255, 255, 255, 0.12)",
        "16": "rgba(255, 255, 255, 0.16)",
      },
    },
    "surface-container-low": {
      main: "rgba(248, 250, 253, 1.00)",
      opacity: {
        "08": "rgba(244, 243, 250, 0.08)",
        "12": "rgba(244, 243, 250, 0.12)",
        "16": "rgba(244, 243, 250, 0.16)",
      },
    },
    "surface-container": {
      main: "rgba(240, 244, 249, 1.00)",
      opacity: {
        "08": "rgba(238, 237, 244, 0.08)",
        "12": "rgba(238, 237, 244, 0.12)",
        "16": "rgba(238, 237, 244, 0.16)",
      },
    },
    "surface-container-high": {
      main: "rgba(233, 238, 246, 1.00)",
      opacity: {
        "08": "rgba(232, 231, 239, 0.08)",
        "12": "rgba(232, 231, 239, 0.12)",
        "16": "rgba(232, 231, 239, 0.16)",
      },
    },
    "surface-container-highest": {
      main: "rgba(221, 227, 234, 1.00)",
      opacity: {
        "08": "rgba(226, 226, 233, 0.08)",
        "12": "rgba(226, 226, 233, 0.12)",
        "16": "rgba(226, 226, 233, 0.16)",
      },
    },
    "success-container": {
      main: "rgba(209, 250, 229, 1.00)",
    },
    "on-success-container": {
      main: "rgba(6, 78, 59, 1.00)",
    },
  },
  typography: {
    // Typography properties (empty for now as requested)
  },
  transitions: {
    // Transition properties (empty for now as requested)
  },
};